import { render, staticRenderFns } from "./heng.vue?vue&type=template&id=46f4ff5f&scoped=true&"
var script = {}
import style0 from "./heng.vue?vue&type=style&index=0&id=46f4ff5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f4ff5f",
  null
  
)

export default component.exports